export { };
declare global {
  interface Array<T> {
    paginate(pageSize: number, page: number): Array<T>;
  }
}


Array.prototype.paginate = function (pageSize: number, page: number) {
  const pagina = page - 1;
  const total = this.length;
  let indexInicio = pagina * pageSize;
  if (indexInicio > total) {
    indexInicio = total - 1;
  }
  let indexFim = (pagina + 1) * pageSize;
  if (indexFim > total) {
    indexFim = total;
  }
  const element = this.slice(indexInicio, indexFim);
  return element;
};
